import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Form, Card, Spinner } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEnvelope, faUser, faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
import './GeneralDonation.css';
import '../DonationForm/DonationForm.css';
import { DonationService, PaymentMethodService, CampaignTypeService, CampaignService, SubscriptionService } from '../../Services/Axios/Api';
// import { AuthService } from '../../Services/Axios/Api';
import CTAPrimaryButton from '../../Components/CTAButton/CTAPrimaryButton/CTAPrimaryButton';
import { getCurrency } from '../../ComponentsMap';
import { t } from 'i18next';
import i18n from '../../Services/i18n/i18n';
import PayPalWrapper from '../../Components/Braintree/PayPalWrapper';
import ReCAPTCHA from "react-google-recaptcha";
import Visa from '../../Assets/Images/Visa.png';
import MasterCard from '../../Assets/Images/MasterCard.png';
import Noon from '../../Assets/Images/noon_payments.png';
import ApplePay from '../../Assets/Images/applepay.png';
import Meeza from '../../Assets/Images/Meeza.png';
import Fawry from '../../Assets/Images/fawry.webp';

import AhlyMomken from '../../Assets/Images/Momken.png';
import { focusFirstInvalidField } from '../../utils/formValidation';

const GENERAL_DONATION_FIELD_ORDER = [
    'type',
    'subCategory',
    'customAmount',
    // 'firstName',
    // 'lastName',
    // 'email',
    // 'phoneNumber',
];

const GeneralDonation = () => {
    // Donation types/sections state
    const [donationType, setDonationType] = useState('one-time');
    const [donationTypes, setDonationTypes] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [loadingTypes, setLoadingTypes] = useState(true);

    // Sub-categories/campaigns state
    const [subCategories, setSubCategories] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [loadingSubCategories, setLoadingSubCategories] = useState(false);

    // Payment methods state
    const [paymentMethods, setPaymentMethods] = useState([]);

    // Form data state
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        amount: '100',
        customAmount: '',
        quantity: 1,
        isCustomQuantity: false,
        message: '',
        paymentMethod: '',
        isAnonymous: false
    });

    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const shouldFocusErrors = useRef(false);

    // Fetch donation types on mount and when donationType changes
    useEffect(() => {
        // Clear selectedType and subcategories synchronously to prevent race conditions
        setSelectedType(null);
        setSubCategories([]);
        setSelectedSubCategory(null);

        const fetchDonationTypes = async () => {
            try {
                setLoadingTypes(true);
                console.log('[GeneralDonation] donationType changed to:', donationType);
                let response;
                if (donationType === 'monthly') {
                    console.log('[GeneralDonation] Calling getRecurringCampaignTypes...');
                    response = await CampaignTypeService.getRecurringCampaignTypes();
                } else {
                    console.log('[GeneralDonation] Calling getGeneralCampaignTypes...');
                    response = await CampaignTypeService.getGeneralCampaignTypes();
                }
                console.log('[GeneralDonation] API response:', JSON.stringify(response));
                const types = response.result || [];
                console.log('[GeneralDonation] Setting donationTypes, count:', types.length, types.map(t => t.name));
                setDonationTypes(types);
                if (types.length > 0) {
                    setSelectedType(types[0].id);
                } else {
                    setSelectedType(null);
                }
            } catch (error) {
                console.error('[GeneralDonation] ERROR fetching donation types:', error);
                console.error('[GeneralDonation] Error details:', error.message, error.stack);
            } finally {
                setLoadingTypes(false);
            }
        };
        fetchDonationTypes();
    }, [donationType]);

    // Fetch payment methods on mount
    useEffect(() => {
        const fetchPaymentMethods = async () => {
            try {
                const response = await PaymentMethodService.getPublicPaymentMethods();
                const methods = response.result || [];
                setPaymentMethods(methods);
                if (methods.length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        paymentMethod: methods[0].provider
                    }));
                }
            } catch (error) {
                console.error('Error fetching payment methods:', error);
            }
        };
        fetchPaymentMethods();
    }, []);

    // Donor identity now comes from the authenticated account, not the form.
    // useEffect(() => {
    //     const fetchUserProfile = async () => {
    //         if (localStorage.getItem('isLoggedIn') === 'true') {
    //             try {
    //                 const response = await AuthService.getProfile();
    //                 if (response.isSuccess && response.result) {
    //                     setFormData(prev => ({
    //                         ...prev,
    //                         firstName: response.result.firstName || '',
    //                         lastName: response.result.lastName || '',
    //                         email: response.result.email || '',
    //                         phoneNumber: response.result.phoneNumber || ''
    //                     }));
    //                 }
    //             } catch (error) {
    //                 console.error('Error fetching user profile:', error);
    //             }
    //         }
    //     };
    //     fetchUserProfile();
    // }, []);

    // Fetch sub-categories when type is selected or donationType changes
    useEffect(() => {
        const fetchSubCategories = async () => {
            if (!selectedType) {
                setSubCategories([]);
                return;
            }
            try {
                setLoadingSubCategories(true);
                console.log('[GeneralDonation] Fetching sub-categories. donationType:', donationType, 'selectedType:', selectedType);
                if (donationType === 'monthly') {
                    console.log('[GeneralDonation] Calling getRecurringCampaigns with sectionId:', selectedType);
                    const response = await CampaignService.getRecurringCampaigns(selectedType);
                    console.log('[GeneralDonation] Recurring campaigns response:', JSON.stringify(response));
                    const filtered = response.result || [];
                    setSubCategories(filtered);
                    if (filtered.length > 0) {
                        setSelectedSubCategory(filtered[0].id);
                    } else {
                        setSelectedSubCategory(null);
                    }
                } else {
                    const response = await CampaignService.getCampaigns();
                    const allCampaigns = response.result || [];
                    const filtered = allCampaigns.filter(c => c.campaignSectionId === selectedType && c.isActive);
                    setSubCategories(filtered);
                    if (filtered.length > 0) {
                        setSelectedSubCategory(filtered[0].id);
                    } else {
                        setSelectedSubCategory(null);
                    }
                }
            } catch (error) {
                console.error('[GeneralDonation] ERROR fetching sub-categories:', error);
                console.error('[GeneralDonation] Error details:', error.message, error.stack);
                setSubCategories([]);
            } finally {
                setLoadingSubCategories(false);
            }
        };
        fetchSubCategories();
    }, [selectedType, donationType]);

    useEffect(() => {
        if (!shouldFocusErrors.current || Object.keys(errors).length === 0) return;
        shouldFocusErrors.current = false;
        focusFirstInvalidField(errors, GENERAL_DONATION_FIELD_ORDER);
    }, [errors]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleTypeSelect = (typeId) => {
        setSelectedType(typeId);
        setSelectedSubCategory(null);
    };

    const handleSubCategorySelect = (itemId) => {
        setSelectedSubCategory(itemId);
    };

    const getPaymentMethodImage = (provider) => {
        const normalizedProvider = provider?.toLowerCase();
        if (normalizedProvider?.includes('visa')) return Visa;
        if (normalizedProvider?.includes('mastercard') || normalizedProvider?.includes('master card')) return MasterCard;
        if (normalizedProvider?.includes('noon')) return Noon;
        if (normalizedProvider?.includes('meeza')) return Meeza;
        if (normalizedProvider?.includes('fawry')) return Fawry;
        if (normalizedProvider?.includes('ahly') || normalizedProvider?.includes('momken')) return AhlyMomken;
        return null;
    };

    const validateForm = () => {
        const newErrors = {};
        // if (!formData.firstName.trim()) newErrors.firstName = t('DonationForm.Validation.FirstNameRequired') || 'الاسم الأول مطلوب';
        // if (!formData.lastName.trim()) newErrors.lastName = t('DonationForm.Validation.LastNameRequired') || 'الاسم الأخير مطلوب';
        // if (!formData.email.trim()) newErrors.email = t('DonationForm.Validation.EmailRequired') || 'البريد الإلكتروني مطلوب';
        // else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) newErrors.email = t('DonationForm.Validation.EmailInvalid') || 'الرجاء إدخال بريد إلكتروني صحيح';
        // if (!formData.phoneNumber.trim()) newErrors.phoneNumber = t('DonationForm.Validation.PhoneNumberRequired') || 'رقم الهاتف مطلوب';
        if (!selectedType) newErrors.type = 'يرجى اختيار وجه التبرع';
        if (!selectedSubCategory) newErrors.subCategory = 'يرجى اختيار برنامج التبرع';
        if (formData.amount === 'custom' && (!formData.customAmount || formData.customAmount < 1)) {
            newErrors.customAmount = t('DonationForm.Validation.CustomAmountRequired') || 'يرجى إدخال مبلغ صحيح';
        }
        return newErrors;
    };

    const getSelectedCampaign = () => subCategories.find(c => c.id === selectedSubCategory);

    const getDonationAmount = () => {
        const campaign = getSelectedCampaign();
        if (campaign?.isFixedPrice) {
            return campaign.fixedPrice * formData.quantity;
        }
        return formData.amount === 'custom' ? formData.customAmount : formData.amount;
    };

    const buildDonationPayload = (paymentMethod) => {
        const campaign = getSelectedCampaign();
        return {
            campaignId: Number(selectedSubCategory),
            amount: parseFloat(getDonationAmount()),
            currency: getCurrency().Appriviation,
            paymentMethod,
            message: formData.message,
            isAnonymous: formData.isAnonymous,
            quantity: campaign?.isFixedPrice ? Number(formData.quantity) : 1
        };
    };

    const handleSubmit = async (e) => {
        setErrors({});
        if (formData.paymentMethod !== 'PayPal') {
            e.preventDefault();
        }

        if (!recaptchaToken) {
            alert("Please verify you're not a robot");
            return;
        }

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            shouldFocusErrors.current = true;
            setErrors(validationErrors);
            return;
        }

        setIsLoading(true);

        try {
            if (donationType === 'monthly') {
                const data = buildDonationPayload('Noon');
                // const data = {
                //     donor: {
                //         name: formData.firstName + " " + formData.lastName,
                //         email: formData.email,
                //         phoneNumber: formData.phoneNumber,
                //         city: "",
                //         country: "",
                //         postalCode: "",
                //         isAnonymous: formData.isAnonymous
                //     },
                //     campaignId: selectedSubCategory,
                //     paymentMethod: 'Noon',
                //     amount: parseFloat(amountVal)
                // };

                const response = await SubscriptionService.createSubscription(data);
                console.log('Subscription response:', response);

                if (response.result && response.result.invoices && response.result.invoices.length > 0) {
                    window.location.href = response.result.invoices[0].paymentUrl;
                } else {
                    console.error("Subscription response didn't contain payment url:", response);
                }
            } else {
                const data = buildDonationPayload(formData.paymentMethod);
                // const data = {
                //     donorInfo: {
                //         name: formData.firstName + " " + formData.lastName,
                //         email: formData.email,
                //         phoneNumber: formData.phoneNumber,
                //         city: "",
                //         country: "",
                //         postalCode: "",
                //         isAnonymous: formData.isAnonymous
                //     },
                //     campaignId: selectedSubCategory,
                //     amount: amountVal,
                //     quantity: subCategories.find(c => c.id === selectedSubCategory)?.isFixedPrice ? formData.quantity : null,
                //     currency: getCurrency().Appriviation,
                //     paymentMethod: formData.paymentMethod,
                //     message: formData.message,
                //     isAnonymous: formData.isAnonymous
                // };

                const response = await DonationService.createDonation(data);
                console.log('Donation response:', response);

                if (formData.paymentMethod === 'PayPal') {
                    return response.result.transactionId;
                } else {
                    window.location.href = response.result;
                }
            }
        } catch (error) {
            console.error('Error creating donation:', error);
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    };

    const handleOnApprove = async (data) => {
        window.location.href = `/callback/PayPal?paymentId=${data.orderID}&payerId=${data.payerID}`;
    };

    const getTypeName = (type) => {
        // If the API returns localized names directly, use them. 
        // Based on DTOs, we might get 'name' which is already localized if the backend handles it,
        // OR we get the full object.
        // Assuming DTO returns 'name'.
        return type.name || type.nameAr || type.nameEn;
    };

    const getItemName = (item) => {
        return item.name || item.nameAr || item.nameEn;
    };

    return (
        <Container className="mt-5 mb-5 d-flex justify-content-center">
            <Col md={10}>
                <Card className="p-4 position-relative DonationFormCard">
                    {isLoading && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 100,
                                borderRadius: '0.375rem'
                            }}
                        >
                            <div className="text-center">
                                <Spinner animation="border" role="status" variant="primary">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p className="mt-2">{t('GeneralDonation.Processing') || 'جاري معالجة تبرعك...'}</p>
                            </div>
                        </div>
                    )}

                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            {/* Donation Type Selection Toggle */}
                            <Form.Group className="mb-4">
                                <Form.Label>{t('GeneralDonation.DonationTypeToggle') || 'نوع التبرع'}*</Form.Label>
                                <div className="donation-type-toggle">
                                    <CTAPrimaryButton
                                        className={`amount-card ${donationType === 'one-time' ? 'filled' : 'outlined'}`}
                                        onClick={(e) => { e.preventDefault(); setDonationType('one-time'); }}
                                        text={t('DonationForm.OneTimeDonation') || 'تبرع مرة واحدة'}
                                    />
                                   {/*} <CTAPrimaryButton
                                        className={`amount-card ${donationType === 'monthly' ? 'filled' : 'outlined'}`}
                                        onClick={(e) => { e.preventDefault(); setDonationType('monthly'); }}
                                        text={t('DonationForm.MonthlyDonation') || 'تبرع شهري'}
                                    />*/}
                                </div>
                            </Form.Group>

                            {/* Step 1: Donation Type Selection - وجه التبرع */}
                            <Form.Group controlId="donationType" id="type" className="mb-4">
                                <Form.Label>{t('GeneralDonation.DonationType') || 'وجه التبرع'}*</Form.Label>
                                {loadingTypes ? (
                                    <div className="text-center py-3">
                                        <Spinner animation="border" size="sm" />
                                    </div>
                                ) : (
                                    <div className="d-flex flex-wrap justify-content-between">
                                        {donationTypes.map((type) => (
                                            <CTAPrimaryButton
                                                key={type.id}
                                                className={`amount-card ${selectedType === type.id ? 'filled' : 'outlined'}`}
                                                onClick={(e) => { e.preventDefault(); handleTypeSelect(type.id); }}
                                                text={getTypeName(type)}
                                            />
                                        ))}
                                    </div>
                                )}
                                {errors.type && (
                                    <div className="text-danger mt-2 small">{errors.type}</div>
                                )}
                            </Form.Group>

                            {/* Step 2: Sub-Category/Program Selection - برنامج التبرع */}
                            {selectedType && (
                                <Form.Group controlId="donationProgram" id="subCategory" className="mb-4">
                                    <Form.Label>{t('GeneralDonation.DonationProgram') || 'برنامج التبرع'}*</Form.Label>
                                    {loadingSubCategories ? (
                                        <div className="text-center py-3">
                                            <Spinner animation="border" size="sm" />
                                        </div>
                                    ) : subCategories.length > 0 ? (
                                        <div className="d-flex flex-wrap justify-content-between">
                                            {subCategories.map((item) => (
                                                <CTAPrimaryButton
                                                    key={item.id}
                                                    className={`amount-card ${selectedSubCategory === item.id ? 'filled' : 'outlined'}`}
                                                    onClick={(e) => { e.preventDefault(); handleSubCategorySelect(item.id); }}
                                                    text={getItemName(item)}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-muted">{t('GeneralDonation.NoPrograms') || 'لا توجد برامج متاحة لهذا الوجه'}</p>
                                    )}
                                    {errors.subCategory && (
                                        <div className="text-danger mt-2 small">{errors.subCategory}</div>
                                    )}
                                </Form.Group>
                            )}

                            {/* Step 3: Donation Amount - مبلغ التبرع */}
                            {subCategories.find(c => c.id === selectedSubCategory)?.isFixedPrice ? (
                                <Form.Group controlId="amount" className="mb-4">
                                    <Row className="mb-4 align-items-end">
                                        <Col xs={6}>
                                            <Form.Label className="fw-bold text-muted">{t('DonationForm.DonationAmount') || 'مبلغ التبرع'}</Form.Label>
                                            <CTAPrimaryButton
                                                className="amount-card filled w-100 m-0"
                                                onClick={(e) => { e.preventDefault(); }}
                                                text={`${getCurrency().Symbol} ${subCategories.find(c => c.id === selectedSubCategory).fixedPrice}`}
                                                style={{ height: '50px' }}
                                            />
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Group controlId="fixedQuantity">
                                                <Form.Label className="fw-bold text-muted">{i18n.exists('DonationForm.Quantity') ? t('DonationForm.Quantity') : 'الكمية'}</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={formData.quantity}
                                                    onChange={(e) => setFormData({ ...formData, quantity: Math.max(1, parseInt(e.target.value) || 1) })}
                                                    min="1"
                                                    className="w-100 text-center fw-bold"
                                                    style={{ height: '50px', fontSize: '1.1rem', borderRadius: '8px' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="text-center p-3 mb-4 rounded shadow-sm mt-3" style={{ backgroundColor: '#f8f9fa', border: '1px dashed #6c757d' }}>
                                        <h5 className="mb-0 fw-bold" style={{ color: '#212529' }}>
                                            {i18n.exists('DonationForm.TotalAmount') ? t('DonationForm.TotalAmount') : 'إجمالي المبلغ'}: {getCurrency().Symbol} {subCategories.find(c => c.id === selectedSubCategory).fixedPrice * formData.quantity}
                                        </h5>
                                    </div>
                                </Form.Group>
                            ) : (
                                <Form.Group controlId="amount" className="mb-4">
                                    <Form.Label>{t('DonationForm.DonationAmount') || 'مبلغ التبرع'}*</Form.Label>
                                    <div className="d-flex flex-wrap justify-content-between">
                                        {['10', '25', '50', '100', '250'].map((value) => (
                                            <CTAPrimaryButton
                                                key={value}
                                                className={`amount-card ${formData.amount === value ? 'filled' : 'outlined'}`}
                                                onClick={(e) => { e.preventDefault(); setFormData({ ...formData, amount: value, customAmount: '' }); }}
                                                text={`${getCurrency().Symbol} ${value}`}
                                            />
                                        ))}
                                        <CTAPrimaryButton
                                            className={`amount-card ${formData.amount === 'custom' ? 'filled' : 'outlined'}`}
                                            onClick={(e) => { e.preventDefault(); setFormData({ ...formData, amount: 'custom' }); }}
                                            text={t('DonationForm.CustomAmount') || 'مبلغ مخصص'}
                                        />
                                    </div>
                                    {formData.amount === 'custom' && (
                                        <Form.Control
                                            type="number"
                                            id="customAmount"
                                            placeholder={t('DonationForm.EnterCustomAmount') || 'ادخل مبلغ مخصص'}
                                            name="customAmount"
                                            value={formData.customAmount}
                                            onChange={handleChange}
                                            min="10"
                                            className="mt-3"
                                            isInvalid={!!errors.customAmount}
                                        />
                                    )}
                                    {errors.customAmount && (
                                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                            {errors.customAmount}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            )}

                            {/* Donor fields are no longer collected on the form — identity comes from the logged-in account.
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="firstName">
                                        <Form.Label>{t('DonationForm.FirstName') || 'الاسم الأول'}*</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('DonationForm.EnterYourFirstName') || 'ادخل اسمك الأول'}
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.firstName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.firstName}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="lastName">
                                        <Form.Label>{t('DonationForm.LastName') || 'الاسم الأخير'}*</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('DonationForm.EnterYourLastName') || 'ادخل اسمك الأخير'}
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.lastName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.lastName}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="email">
                                        <Form.Label>{t('DonationForm.Email') || 'البريد الإلكتروني'}*</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faEnvelope} /></InputGroup.Text>
                                            <Form.Control
                                                type="email"
                                                placeholder={t('DonationForm.EnterYourEmail') || 'ادخل بريدك الإلكتروني'}
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="phoneNumber">
                                        <Form.Label>{t('DonationForm.PhoneNumber') || 'رقم الهاتف'}*</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faPhone} /></InputGroup.Text>
                                            <Form.Control
                                                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                                                type="tel"
                                                placeholder={t('DonationForm.EnterYourPhoneNumber') || 'ادخل رقم هاتفك'}
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.phoneNumber}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.phoneNumber}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            */}



                            <Form.Group controlId="message" className="mb-3">
                                <Form.Label>{t('DonationForm.Message') || 'الرسالة'}</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder={t('DonationForm.EnterYourMessage') || 'ادخل رسالتك (اختياري)'}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </Form.Group>

                            {/* Payment Method Selection */}
                            {donationType === 'monthly' ? (
                                <div className="noon-only-notice mb-4">
                                    <span>{t('DonationForm.NoonOnlyNotice') || 'الدفع الشهري يتم عبر بوابة Noon فقط'}</span>
                                    <img src={Noon} width={50} alt="Noon Payments" className="m-2" />
                                </div>
                            ) : (
                                paymentMethods.length > 1 ? (
                                    <Form.Group controlId="paymentMethod" className="mb-3">
                                        <Form.Label>
                                            {t('DonationForm.PaymentMethod') || 'بوابة الدفع'}
                                            <img src={getPaymentMethodImage("Meeza")} width={50} alt="Payment Method" className='m-2' />
                                            <img src={getPaymentMethodImage("Visa")} width={50} alt="Payment Method" className='m-2' />
                                            <img src={getPaymentMethodImage("MasterCard")} width={50} alt="Payment Method" className='m-2' />
                                        </Form.Label>
                                        <p>{t('DonationForm.Disclaimer')}</p>
                                        <div>
                                            {paymentMethods
                                                .sort((a, b) => (a.order || 0) - (b.order || 0))
                                                .map((method) => {
                                                    const methodName = method.name;
                                                    const methodProvider = method.provider;
                                                    return (
                                                        <React.Fragment key={methodProvider}>
                                                            {i18n.language === 'ar' ? (
                                                                <div className='d-flex align-items-center'>
                                                                    <input type="radio" className='m-2 form-check-input' name="paymentMethod" id={methodProvider} value={methodProvider} checked={formData.paymentMethod === methodProvider} onChange={handleChange} />
                                                                    <label htmlFor={methodProvider}>{methodProvider === 'Noon' ? 'Noon Payments' : methodName} <img src={getPaymentMethodImage(methodProvider)} width={50} alt={methodName} className='m-2' /></label>
                                                                    {methodProvider === 'Noon' && <img src={ApplePay} width={50} alt="Apple Pay" className='m-2' />}
                                                                </div>
                                                            ) : (
                                                                <div className='d-flex align-items-center'>
                                                                    <input type="radio" className='m-2 form-check-input' name="paymentMethod" id={methodProvider} value={methodProvider} checked={formData.paymentMethod === methodProvider} onChange={handleChange} />
                                                                    <label htmlFor={methodProvider}>{methodProvider === 'Noon' ? 'Noon Payments' : methodName}
                                                                        <img src={getPaymentMethodImage(methodProvider)} width={50} alt={methodName} className='m-2' />
                                                                        {methodProvider === 'Noon' && <img src={ApplePay} width={50} alt="Apple Pay" className='m-2' />}
                                                                    </label>
                                                                </div>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                        </div>
                                    </Form.Group>
                                ) : null
                            )}

                            {/* Submit Button */}
                            <div className="secure-payment-disclaimer">
                                <div className="secure-shield">
                                    <svg width="60" height="70" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M30 0L5 11.25V33.75C5 50.85 15.65 66.75 30 70C44.35 66.75 55 50.85 55 33.75V11.25L30 0Z" fill="#00C09A" />
                                        <path d="M24.75 46.25L14.75 36.25L18.25 32.75L24.75 39.25L41.75 22.25L45.25 25.75L24.75 46.25Z" fill="white" />
                                    </svg>
                                </div>
                                <div className="secure-text">
                                    {t('DonationForm.SecurePaymentDisclaimer') || 'كل بياناتك ومعاملاتك آمنة'}
                                </div>
                            </div>
                            <div className="w-100">
                                <div className="d-flex justify-content-center mb-3">
                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeUyq4sAAAAAED6EEYKWhqPNMVhimC1mSNqRN9t"}
                                        onChange={(value) => setRecaptchaToken(value)}
                                    />
                                </div>
                                {formData.paymentMethod === 'PayPal' ? (
                                    <PayPalWrapper handleCreateOrder={handleSubmit} handleOnApprove={(data) => handleOnApprove(data)} />
                                ) : (
                                    <CTAPrimaryButton
                                        className="w-100"
                                        text={t('DonateNow') || 'تبرع الآن'}
                                        onClick={(e) => handleSubmit(e)}
                                    />
                                )}
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Container>
    );
};

export default GeneralDonation;
